// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__XBbqW","inner":"Footer_inner__wSIkW","nextIcon":"Footer_nextIcon__2t1-d","innerLeft":"Footer_innerLeft__2VTRy"};